import { render } from "./ResetPassword.vue?vue&type=template&id=7fcf22ab"
import script from "./ResetPassword.vue?vue&type=script&lang=js"
export * from "./ResetPassword.vue?vue&type=script&lang=js"

import "./ResetPassword.vue?vue&type=style&index=0&id=7fcf22ab&lang=scss"
script.render = render

export default script